export default function IconNavArrowRight({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0.53 0.52 16.95 16.95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M10.7375 9.80173C10.854 9.70275 10.9475 9.57963 11.0117 9.4409C11.0758 9.30217 11.1091 9.15115 11.1091 8.9983C11.1091 8.84545 11.0758 8.69443 11.0117 8.5557C10.9475 8.41697 10.854 8.29385 10.7375 8.19487L2.82968 1.33862C2.67613 1.2082 2.48843 1.12451 2.28879 1.09745C2.08916 1.07038 1.88595 1.10108 1.70322 1.1859C1.52049 1.27072 1.36588 1.40612 1.25769 1.57607C1.14951 1.74602 1.09228 1.9434 1.09278 2.14486V15.8517C1.09282 16.053 1.15044 16.25 1.25883 16.4195C1.36723 16.589 1.52187 16.724 1.7045 16.8085C1.88713 16.893 2.09011 16.9234 2.28949 16.8962C2.48887 16.8691 2.67631 16.7854 2.82968 16.6552L10.7375 9.80173Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.89161 15.3263V15.8528C6.89165 16.054 6.94927 16.251 7.05766 16.4205C7.16606 16.5901 7.3207 16.725 7.50333 16.8095C7.68595 16.894 7.88894 16.9244 8.08832 16.8973C8.2877 16.8701 8.47514 16.7865 8.62851 16.6562L16.5363 9.80276C16.6528 9.70378 16.7464 9.58066 16.8105 9.44193C16.8747 9.3032 16.9079 9.15218 16.9079 8.99933C16.9079 8.84648 16.8747 8.69546 16.8105 8.55673C16.7464 8.418 16.6528 8.29488 16.5363 8.19589L8.62922 1.33824C8.47568 1.20761 8.28791 1.12373 8.08816 1.09655C7.88841 1.06936 7.68506 1.10001 7.50219 1.18486C7.31933 1.2697 7.16462 1.4052 7.05641 1.57528C6.94819 1.74536 6.891 1.9429 6.89161 2.14448V2.67378"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
